import React from 'react';

import { Menu } from '@hcs/design-system';
import { CardTabs, Tab } from '@hcs/design-system';
import { useExperienceFlag } from '@hcs/experience-flags';

import { ClientFileIdRequiredControl } from '../../features/OrgReportPreferences/ClientFileIdRequiredControl';
import { CompTagsOptionsControl } from '../../features/OrgReportPreferences/CompTagsOptionsControl';
import { DefaultValuationMethodControl } from '../../features/OrgReportPreferences/DefaultValuationMethodControl';
import { SelectedCompsLimitControl } from '../../features/OrgReportPreferences/SelectedCompsLimitControl';
import { WebhookSettingsControl } from '../../features/OrgReportPreferences/WebhookSettingsControl';

import { AllowPublicLinksControl } from './AllowPublicLinksControl';
import { IntraOrgReportAccessControl } from './IntraOrgReportAccessControl';

interface Props {
  className?: string;
}
const dataHcName = 'org-report-preferences';
export const OrgReportPreferences = ({ className }: Props) => {
  const webhookExpFlag = useExperienceFlag('REPORT_API_WEBHOOK');
  const tabs: Tab[] = [
    {
      tabId: `${dataHcName}-report-access`,
      label: 'Report Access',
      content: (
        <Menu>
          <IntraOrgReportAccessControl />
          <AllowPublicLinksControl />
        </Menu>
      ),
    },
    {
      tabId: `${dataHcName}-report-creation`,
      label: 'Report Creation',
      content: (
        <Menu>
          <ClientFileIdRequiredControl />
          <DefaultValuationMethodControl valueType="SOLD" />
          <DefaultValuationMethodControl valueType="RENTAL" />
        </Menu>
      ),
    },
    {
      tabId: `${dataHcName}-report-content`,
      label: 'Report Content',
      content: (
        <Menu>
          <SelectedCompsLimitControl />
          <CompTagsOptionsControl />
        </Menu>
      ),
    },
  ];
  if (webhookExpFlag) {
    tabs.push({
      tabId: `${dataHcName}-report-notifications`,

      label: 'Notifications',
      content: (
        <Menu>
          <WebhookSettingsControl />
        </Menu>
      ),
    });
  }
  return (
    <CardTabs
      searchParamId={dataHcName}
      className={className}
      maxWidth={800}
      dataHcName={dataHcName}
      tabs={tabs}
    />
  );
};
